<template>
  <div class="box">
    <com-h1 :title="$store.state.isPastHot === 1 ? '往届热门议题' : '热门议题'"></com-h1>
    <com-swipe :items="appliededHotLecturesArr"></com-swipe>
    <!-- <ul>
      <li v-for="(lecture, index) of hotLectures" :key="index">
        {{lecture.id}}{{lecture.title}}
      </li>
    </ul> -->
  </div>
</template>
<script>
import comH1 from 'gkConUI/com-h1'
import comSwipe from './com-swipe'

export default {
  data () {
    return {}
  },
  components: {
    comH1,
    comSwipe
  },
  props: ['appliededHotLecturesArr']
}
</script>
<style scoped lang='sass'>
</style>
